var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{class:_vm.invisible ? ' invisible' : '',attrs:{"color":_vm.color,"flat":"","round":"","dense":"","icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }